module.exports = __webpack_public_path__ + "images/4-ru.211a57d684b8a4ee2ae2249e18690adc.jpg";